import { request } from "../../config/API";
import authHeader from "./authHeader";

const endPoints = [
  // index 0
  {
    end: "leadgeneration/getSubscribedPlan",
    method: "get",
    description: "get subscribed plan",
  },
  // index 1
  {
    end: "leadgeneration/createCheckoutSession",
    method: "post",
    description: "create checkout session",
  },
  // index 2
  {
    end: "leadgeneration/cancelSubscribedPlanBeta", //remove beta
    method: "post",
    description: "cancel subscribed plan",
  },
  //index 3
  {
    end: "leadgeneration/stripId",
    method: "get",
    description: "get stripe id",
  },
  //index 4
  {
    end: "leadgeneration/changeSubscriptionPlanBeta", //remove beta
    method: "post",
    description: "change subscription",
  },
  //index 5

  {
    end: "leadgeneration/buySubscriptionPlanBeta", // remove beta
    method: "post",
    description: "buy subscription plan",
  },
];

const getSubscribedPlan = () =>
  request.get(endPoints[0].end, {
    headers: { ...authHeader() },
  });

const createCheckoutSession = (wavecardQuantity) =>
  request.post(
    endPoints[1].end,
    { wavecardQuantity },
    {
      headers: { ...authHeader() },
    }
  );
const buySubscriptionPlan = (payload) =>
  request.post(endPoints[5].end, payload, {
    headers: { ...authHeader() },
  });
const changeSubscriptionPlan = (payload) =>
  request.post(endPoints[4].end, payload, {
    headers: { ...authHeader() },
  });
const cancelSubscribedPlan = () =>
  request.post(endPoints[2].end, null, { headers: { ...authHeader() } });
const getStripeId = () => request.get(endPoints[3].end);
const membershipFunctions = {
  getSubscribedPlan,
  createCheckoutSession,
  buySubscriptionPlan,
  cancelSubscribedPlan,
  getStripeId,
  changeSubscriptionPlan,
};

export default membershipFunctions;
